import React from 'react';
import PropTypes from 'prop-types';
import { DandDFreeIcon, DandDPenaltyIcon, DandDRiskIcon } from '../icons/icons';
import Tooltip from '../tooltip/tooltip';
import './d&d-modes.scss';

export function DandDModes({ mode, value }) {
  return (
    <div className="d-and-d-mode">
      {mode?.toLowerCase()?.includes('free') && (
        <span className="mode free">
          <span className="d-and-d-mode-value">{value}</span>
          <Tooltip content={mode}>
            <DandDFreeIcon />
          </Tooltip>
        </span>
      )}
      {mode?.toLowerCase()?.includes('risk') && (
        <span className="mode risk">
          <span className="d-and-d-mode-value">{value}</span>
          <Tooltip content={mode}>
            <DandDRiskIcon />
          </Tooltip>
        </span>
      )}
      {mode?.toLowerCase()?.includes('penalty') && (
        <span className="mode penalty">
          <span className="d-and-d-mode-value">{value}</span>
          <Tooltip content={mode}>
            <DandDPenaltyIcon />
          </Tooltip>
        </span>
      )}
      {/* <DandDFreeIcon /> */}
    </div>
  );
}

DandDModes.propTypes = {
  mode: PropTypes.string,
  value: PropTypes.string,
};
DandDModes.defaultProps = {
  mode: 'D&D Free',
  value: '06',
};

export function DandDModeGroup({ data }) {
  return (
    <div className="d-and-d-mode-group">
      {data?.map((val) => (
        <DandDModes mode={val?.label} value={val?.count} />
      ))}
    </div>
  );
}

DandDModeGroup.propTypes = {
  data: PropTypes.instanceOf(Array),
};
DandDModeGroup.defaultProps = { data: [] };
